import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiCoffee } = FiIcons;

export default function MealPlanWidget() {
  return (
    <div className="bg-gradient-to-br from-[#1a365d] to-blue-900 rounded-3xl p-6 shadow-lg text-white">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold flex items-center gap-2">
          <SafeIcon icon={FiCoffee} className="text-yellow-300" />
          Meal Plan
        </h3>
        <span className="text-xs font-medium bg-white/20 px-2 py-1 rounded-lg backdrop-blur-sm">Tuesday</span>
      </div>
      
      <div className="space-y-3">
        <div className="bg-white/10 rounded-xl p-3 backdrop-blur-sm border border-white/10">
          <span className="text-xs text-yellow-200 font-semibold uppercase tracking-wider block mb-1">Dinner</span>
          <h4 className="font-bold text-lg">Taco Tuesday 🌮</h4>
          <p className="text-sm text-slate-300 mt-1">Prep: Defrost beef by 4 PM</p>
        </div>
      </div>
    </div>
  );
}